import { render } from "./LotDescription.vue?vue&type=template&id=761cb90c&scoped=true"
import script from "./LotDescription.vue?vue&type=script&lang=js"
export * from "./LotDescription.vue?vue&type=script&lang=js"

import "./LotDescription.vue?vue&type=style&index=0&id=761cb90c&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761cb90c"]])

export default __exports__